import React from 'react'
import { css, cx } from '@emotion/css'
import { legacyTheme } from '../legacy-theme'

interface TableRowProps {
  readonly children: React.ReactNode
  readonly isFirstRow?: boolean
  readonly isLastRow?: boolean
  readonly className?: string
  readonly dataTestID?: string
}

export function TableRow({
  children,
  isFirstRow = false,
  isLastRow = false,
  className,
  dataTestID
}: TableRowProps) {
  return (
    <tr
      data-testid={dataTestID}
      className={cx(
        'legacy-ds-grid-table-row',
        {
          [css`
            border-top: 1px solid ${legacyTheme.colors.tableBorder};
            min-height: 48px;
          `]: !isFirstRow,
          [css`
            border-bottom: 1px solid ${legacyTheme.colors.tableBorder};
          `]: isLastRow
        },
        css`
          align-items: center;
        `,
        className
      )}
    >
      {children}
    </tr>
  )
}
